import React from 'react';
import StatusBasedProjects from './StatusBasedProjects';

const FinalReportProjects = () => {
  return (
    <StatusBasedProjects 
      status="FINALREPORT"
      title="Final Report Projects"
    />
  );
};

export default FinalReportProjects;